import { render, staticRenderFns } from "./LobbyPage.vue?vue&type=template&id=72e4e8d5&scoped=true&lang=pug&"
import script from "./LobbyPage.vue?vue&type=script&lang=ts&"
export * from "./LobbyPage.vue?vue&type=script&lang=ts&"
import style0 from "./LobbyPage.vue?vue&type=style&index=0&id=72e4e8d5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4e8d5",
  null
  
)

component.options.__file = "LobbyPage.vue"
export default component.exports